import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M9 5a3 3 0 1 1 6 0v5a3 3 0 1 1-6 0z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M6 9a1 1 0 0 1 1 1 5 5 0 1 0 10 0 1 1 0 1 1 2 0 7 7 0 0 1-6 6.928V20h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2v-3.072A7 7 0 0 1 5 10a1 1 0 0 1 1-1"
    }
  )
);
var SvgMicOnFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MicOnFilled_default = SvgMicOnFilled;

export { MicOnFilled_default as default };
